module.exports = __webpack_public_path__ + "img/shoe.4dad179a.jpg";